class EngravingModule extends HTMLElement {
    constructor() {
        super();

        this.componentName = {
            data: '[type="text/template"]',
            opener: '[name="toggle-engraving-module"]',
            remove: '[name="remove-engraving-module"]',
            edit: '[name="edit-engraving-module"]',
            textInput: '[name="selectedText"]',
            textInputLabel: '.engraving-input',
            additionalOptions: '#engraving-additional-items',
            options: '.engraving-item',
            cancel: '.engraving-module-purchase__cancel',
            continue: '.engraving-module-purchase__continue',
            colors: '.engraving-module-color',
            spinner: '.engraving-module-modal__loading',
            toggles: '.tabs__item',
            tabs: '.tabs-content__item',
            accordionHeading: '.accordion__list-item-heading',
            selectedColor: '.engraving-module-colors__selected',
            image: '#engraving-image',
            modal: '#engraving-modal',
            component: '#engraving-module-component',
            text: '#engraving-text',
            templates: {
                accordionItem: '#template-engraving-accordion-item',
                productImage: '#template-engraving-product-image',
                modal: '#template-engraving-modal',
                component: '#template-engraving-module-component',
                componentSuccess: '#template-engraving-module-component-success',
                text: '#template-engraving-modal-text'
            }
        }
        this.hasInit = {
            modal: false,
            text: false
        };
        this.data = JSON.parse(this.querySelector(this.componentName.data).innerHTML);
        this.filePath = this.data.filePath.split('/').slice(0, -1).join('/');
        this.templates = {
            accordionItem: this.querySelector(this.componentName.templates.accordionItem).innerHTML,
            productImage: this.querySelector(this.componentName.templates.productImage).innerHTML,
            modal: this.querySelector(this.componentName.templates.modal).innerHTML,
            component: this.querySelector(this.componentName.templates.component).innerHTML,
            componentSuccess: this.querySelector(this.componentName.templates.componentSuccess).innerHTML,
            text: this.querySelector(this.componentName.templates.text).innerHTML
        }
        this.activeTab = null;
        this.selected = null;

        const openButton = this.querySelector(this.componentName.opener);
        openButton.addEventListener('click', this.handleEngravingOpening.bind(this));
        document.addEventListener('variant:change', this.syncColorOption.bind(this));
    }

    init() {
        this.toggleLoading();
        this.renderModal();
        this.renderAdditionalOptions();
        this.renderImages();
        this.toggleLoading();
        this.hasInit.modal = true;

        this.activeTab = this.querySelector(`.tabs-content__item`);
        this.activeTab.querySelector(this.componentName.options).click();
        this.querySelectorAll(this.componentName.toggles).forEach((toggle) => {
            toggle.addEventListener('click', this.handleToggleTab.bind(this));
        });
    }

    toggleLoading() {
        this.querySelector(this.componentName.spinner).classList.toggle('engraving-module-modal__loading--active')
    }

    toggleContent(tabId) {
        this.querySelectorAll(this.componentName.tabs).forEach((tab) => {
            this.tabAttr = tab.getAttribute('data-attr');
            if (!this.tabAttr) return;

            if (this.tabAttr === tabId) {
                tab.classList.add('tabs-content__item--active');
            } else {
                tab.classList.remove('tabs-content__item--active');
            }
        });
    }

    toggleAccordion(wrapper) {
        if (wrapper.classList.contains('active')) {
            wrapper.classList.remove('active');
        } else {
            var allItems = this.querySelectorAll('.accordion__list-item.active');
            if (allItems.length > 0) {
                allItems.forEach((item) => {
                    item.classList.remove('active');
                });
            }

            wrapper.classList.add('active');
        }
    }

    toggleEngravingBuilder(modifer) {
        const enable = modifer != undefined ? modifer : !this.classList.contains('engraving-module--active');
        this.classList.toggle('engraving-module--active', enable);
        document.body.classList.toggle('overflow-hidden', enable);
        if (enable) {
            if (this.selected == null || this.selected?.personalisation == null) {
                this.selected = {
                    color: this.selected?.color ? this.selected.color : this.data.product.selectedOrFirstAvailableVariant.options[this.data.product.colors_index],
                    personalisation: this.data.metafield_data.additionalOptions[0].options[0],
                    groupTitle: this.data.metafield_data.additionalOptions[0].groupTitle
                }
            }
            if (!this.hasInit.modal) {
                this.init();
            } else {
                this.renderImages();
            }
        }
    }

    getAdjustedImages(image, width) {
        var url = new URL(`https:${image}`);
        url.searchParams.append('width', width);
        return url.toString();
    }

    getPersonalisation(attributes) {
        if (attributes.groupTitle === 'Texte') {
            return this.data.metafield_data.fonts.options.find((option) => attributes.title === option.title);
        } else {
            const group = this.data.metafield_data.additionalOptions.find((option) => attributes.groupTitle === option.groupTitle);
            return group.options.find((option) => option.title == attributes.title);
        }
    }

    syncColorOption(event) {
        const varaint = event.detail.variant;
        this.colorSwitch(varaint.options[this.data.product.colors_index]);
        this.renderPageComponent();
    }

    preloadImage(imgSrc, callback) {
        var objImagePreloader = new Image();
        objImagePreloader.src = imgSrc;

        if (objImagePreloader.complete) {
            callback();
        } else {
            objImagePreloader.onload = function () {
                callback();
            }

            objImagePreloader.onerror = function () {
                callback();
            }
        }
    }

    colorSwitch(color) {
        if (!this.selected) this.selected = {}
        this.selected.color = color;
        if (this.querySelector(this.componentName.selectedColor))
            this.querySelector(this.componentName.selectedColor).textContent = color;
        this.querySelectorAll(this.componentName.colors).forEach((option) => {
            option.classList.toggle('engraving-module-color--active', option.dataset.attr === color);
        });
        document.querySelector(`.color-variant input[value="${color}"`).click();

        if (this.selected.personalisation != null)
            this.renderImages();
    }

    handleEngravingOpening(event) {
        event.preventDefault();
        this.toggleEngravingBuilder();
    }

    handleColorSwitch(event) {
        event.preventDefault();
        this.colorSwitch(event.target.dataset.attr)
    }

    handlePersonalisationSwitch(event) {
        const switchAttriutes = Object.assign({}, event.target.dataset);
        const personalisation = this.getPersonalisation(switchAttriutes);

        this.selected.personalisation = personalisation;
        this.selected.groupTitle = switchAttriutes.groupTitle;
        this.querySelectorAll(this.componentName.options).forEach((option) => {
            if (option === event.target) {
                option.classList.add('engraving-item--active')
            } else {
                option.classList.remove('engraving-item--active')
            }
        });
        this.renderImages();
    }

    handleContinue(event) {
        event.preventDefault();
        let textInputIsValid = true;
        if (this.hasInit.text) {
            textInputIsValid = this.checkEngravingText(this.selected.inputText);
        }

        if (textInputIsValid) {
            this.renderPageComponent();
            this.toggleEngravingBuilder();
        } else {
            this.handleErrorMessageOnSubmit();
        }
    }

    checkEngravingText(text) {
        let validText = true;
        $.ajax({
            type: "GET",
            url: this.data.banned_words_file,
            async: false,
            success: function (response) {
                for (var i = 0; i < response.length; i++) {
                    const word = response[i].toLowerCase();
                    const regex = new RegExp(`\\b${word}\\b`, 'i');

                    if (regex.test(text)) {
                        validText = false;
                        break;
                    }
                }
            }
        });

        return validText;
    }

    handleRemoveEngraving(event) {
        event.preventDefault();
        this.selected = null;
        this.renderPageComponent();
        this.toggleEngravingBuilder(false);
    }

    handleEditEngraving(event) {
        event.preventDefault();
        this.toggleEngravingBuilder();
    }

    handleToggleTab(event) {
        event.preventDefault();
        const tabId = event.target.getAttribute('name');
        this.activeTab = this.querySelector(`.tabs-content__item[data-attr="${tabId}"]`);
        this.querySelectorAll(this.componentName.toggles).forEach((toggle) => {
            if (toggle === event.target) {
                toggle.classList.add('tabs__item--active');
            } else {
                toggle.classList.remove('tabs__item--active');
            }
            this.toggleContent(tabId);
        });
        if (tabId === 'text' && !this.hasInit.text) {
            this.renderTextTab()
            this.hasInit.text = true;
        }
        if (tabId === 'text') {
            this.continueButton.setAttribute('disabled', 'disabled');
        } else {
            this.continueButton.removeAttribute('disabled');
        }

        delete this.selected["inputText"];
        this.querySelector(this.componentName.textInput).value = "";
        this.activeTab.querySelector(this.componentName.options).click();
    }

    handleToggle(event) {
        event.preventDefault();
        const wrapper = event.target.closest('.accordion__list-item');
        if (wrapper)
            this.toggleAccordion(wrapper);
    }

    handleTextInput(event) {
        event.target.value = event.target.value.replace(/[^a-zA-Z0-9 ]/g, '');
        if (event.target.value.length >= 10) {
            event.target.value = event.target.value.substring(0, 10);
        }
    }

    handleTextInputDown(event) {
        if (event.target.value.length >= 10 && event.key != 'Backspace' && event.key != 'Tab' && event.key != 'ArrowLeft' && event.key != 'ArrowRight' || event.key == '|') {
            event.preventDefault()
            return;
        };
    }

    handleTextInputUp(event) {
        this.selected.inputText = event.target.value;
        if (event.target.value.trim().length > 0) {
            this.continueButton.removeAttribute('disabled');
        } else {
            this.continueButton.setAttribute('disabled', 'disabled');
        }
    }

    handleErrorMessageOnSubmit() {
        const inputLabel = document.querySelector(this.componentName.textInputLabel);
        const inputLabelSpan = inputLabel.querySelector('span');
        const errorMessage = inputLabelSpan.dataset.error;
        const defaultSpanValue = inputLabelSpan.innerHTML;
        inputLabel.classList.add('error');
        inputLabelSpan.classList.add('error');
        inputLabelSpan.innerHTML = errorMessage;
        setTimeout(function () {
            inputLabel.classList.remove('error');
            inputLabelSpan.classList.remove('error');
            inputLabelSpan.innerHTML = defaultSpanValue;
        }, 2000);
    }

    renderImages() {
        const originalThis = this;
        const firstPersonalisation = this.data.metafield_data.additionalOptions[0].options[0].images[this.selected.color];
        const personalisation = this.selected.personalisation ? this.selected.personalisation : firstPersonalisation;
        this.querySelector(this.componentName.image).innerHTML = "";

        const desktopImage = this.getAdjustedImages(this.filePath + '/' + personalisation.images[this.selected.color].desktop, 500);
        const mobileImage = this.getAdjustedImages(this.filePath + '/' + personalisation.images[this.selected.color].mobile, 500);
        const currentImage = window.matchMedia("(min-width: 1024px)") ? desktopImage : mobileImage
        this.toggleLoading();
        this.preloadImage(currentImage, function () {
            originalThis.toggleLoading();
        })

        originalThis.querySelector(originalThis.componentName.image).innerHTML += originalThis.render(originalThis.templates.productImage, {
            imageDesktop: desktopImage,
            imageMobile: mobileImage,
        });
    }

    renderAdditionalOptions() {
        this.querySelector(this.componentName.additionalOptions).innerHTML = "";
        this.data.metafield_data.additionalOptions.forEach((option, i) => {
            const orderedOptions = option.options.sort(function (a, b) {
                var textA = a.title.toUpperCase();
                var textB = b.title.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            })

            this.querySelector(this.componentName.additionalOptions).innerHTML += this.render(this.templates.accordionItem, {
                ...option,
                options: orderedOptions
            });
        });
        this.querySelectorAll(this.componentName.options).forEach((option) => {
            option.addEventListener('click', this.handlePersonalisationSwitch.bind(this));
        })
        this.querySelectorAll(this.componentName.accordionHeading).forEach((heading) => {
            heading.addEventListener('click', this.handleToggle.bind(this));
        });
    }

    renderModal() {
        const selectedColor = this.selected.color ? this.selected.color : this.data.product.colors[0].title;
        this.querySelector(this.componentName.modal).innerHTML = "";
        this.querySelector(this.componentName.modal).innerHTML += this.render(this.templates.modal, {
            ...this.data,
            selectedColor: function () {
                return selectedColor
            },
            selectedColorState: function () {
                return this.title == selectedColor
            }
        });

        this.cancelButton = this.querySelector(this.componentName.cancel);
        this.continueButton = this.querySelector(this.componentName.continue);
        const colors = this.querySelectorAll(this.componentName.colors);
        this.cancelButton.addEventListener('click', this.handleRemoveEngraving.bind(this));
        this.continueButton.addEventListener('click', this.handleContinue.bind(this));
        colors.forEach((color) => color.addEventListener('click', this.handleColorSwitch.bind(this)))
    }

    renderPageComponent() {
        if (this.selected?.personalisation != null) {
            this.querySelector(this.componentName.component).innerHTML = "";
            this.querySelector(this.componentName.component).innerHTML += this.render(this.templates.componentSuccess, this.selected);
            this.querySelector(this.componentName.remove).addEventListener('click', this.handleRemoveEngraving.bind(this))
            this.querySelector(this.componentName.edit).addEventListener('click', this.handleEditEngraving.bind(this))
        } else {
            this.querySelector(this.componentName.component).innerHTML = "";
            this.querySelector(this.componentName.component).innerHTML += this.render(this.templates.component);
            this.querySelector(this.componentName.opener).addEventListener('click', this.handleEngravingOpening.bind(this));
        }
    }

    renderTextTab() {
        const container = this.querySelector(this.componentName.text);
        container.innerHTML = "";
        container.innerHTML += this.render(this.templates.text, this.data.metafield_data.fonts);
        container.querySelectorAll(this.componentName.options).forEach((option) => {
            option.addEventListener('click', this.handlePersonalisationSwitch.bind(this));
        });
        document.querySelector(this.componentName.textInput).addEventListener('input', this.handleTextInput.bind(this));
        document.querySelector(this.componentName.textInput).addEventListener('keydown', this.handleTextInputDown.bind(this));
        document.querySelector(this.componentName.textInput).addEventListener('keyup', this.handleTextInputUp.bind(this));
    }

    render(template, data) {

        const originalThis = this;
        const locales = this.data.locales;

        function getSelectedImage(color, deviceType) {
            const basePath = originalThis.filePath + '/';
            const images = originalThis.selected.personalisation.images[color];
            if (images) {
                const imagePath = images.mobile;
                return originalThis.getAdjustedImages(basePath + imagePath, 500);
            }
        }

        return Mustache.render(template, {
            ...data,
            locales,
            iconLibrary: function () {
                return originalThis.filePath + "/" + this.icon;
            },
            personalisationTitle: function () {
                return originalThis.selected.inputText ? originalThis.selected.inputText : originalThis.selected.personalisation.title
            },
            personalisationValue: function () {
                return originalThis.selected.inputText ? `${originalThis.selected.inputText}|${originalThis.selected.personalisation.title}` : originalThis.selected.personalisation.title
            },
            imageMobile: function () {
                return getSelectedImage(originalThis.selected.color, 'mobile');
            }
        });
    }
}

customElements.define('engraving-module', EngravingModule);
